import { render, staticRenderFns } from "./PscDeficiencyCorrectiveAction.vue?vue&type=template&id=6f483335&scoped=true&"
import script from "./PscDeficiencyCorrectiveAction.vue?vue&type=script&lang=js&"
export * from "./PscDeficiencyCorrectiveAction.vue?vue&type=script&lang=js&"
import style0 from "./PscDeficiencyCorrectiveAction.vue?vue&type=style&index=0&id=6f483335&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f483335",
  null
  
)

export default component.exports